var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 5.63701C17.3592 6.18068 15.1481 6.64376 12.6364 5.6634C9.69934 4.51702 7.28365 5.73933 5.75 6.73138V14.2294C6.33563 13.9382 7.02094 13.6763 7.82732 13.5181C9.29114 13.231 11.0742 13.2997 13.3093 14.0267C16.3302 15.0093 18.1224 13.9343 18.75 13.4327V5.63701ZM18.9152 3.34643C19.679 2.9012 20.75 3.40819 20.75 4.39421V13.7949C20.75 14.0743 20.6513 14.3821 20.4121 14.6251C19.9005 15.1448 17.2898 17.4246 12.6907 15.9286C10.7283 15.2903 9.2927 15.2688 8.21234 15.4807C7.12805 15.6934 6.32143 16.1559 5.61502 16.6234C4.82499 17.1462 3.75 16.5904 3.75 15.6224V6.30146C3.75 5.91116 3.9401 5.53562 4.27708 5.30806C5.83009 4.25932 9.17937 2.16711 13.3636 3.80029C15.9566 4.8124 18.143 3.79652 18.9152 3.34643Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 3C5.30228 3 5.75 3.44772 5.75 4L5.75 21C5.75 21.5523 5.30228 22 4.75 22C4.19771 22 3.75 21.5523 3.75 21L3.75 4C3.75 3.44772 4.19772 3 4.75 3Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.5C6.5 4.4665 5.7165 5.25 4.75 5.25C3.7835 5.25 3 4.4665 3 3.5C3 2.5335 3.7835 1.75 4.75 1.75C5.7165 1.75 6.5 2.5335 6.5 3.5Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagX2);
export default __webpack_public_path__ + "static/media/FlagX2.4cda0f1f54c8567de22426d2eb83d17d.svg";
export { ForwardRef as ReactComponent };